import React from 'react';
import styles from '../SaleReportPage.module.scss';

function LayoutCard({ layouts, value, onChange }) {
  const cols = layouts.length <= 3 ? styles.layoutRowCols3 : '';

  return (
    <div className={`${styles.layoutRow} ${cols}`}>
      {layouts.map((layout) => {
        const isOn = layout.key === value;
        const cardClass = `${styles.layoutCard} ${isOn ? styles.layoutCardOn : ''}`;

        return (
          <button
            key={layout.key}
            type="button"
            className={cardClass}
            disabled={layout.disabled}
            onClick={() => !layout.disabled && onChange(layout.key)}
            style={layout.disabled ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
          >
            <span className={styles.layoutCardThumb}>
              <span
                className={styles.layoutCardGrid}
                style={layout.gridStyle}
              >
                {layout.cells.map((cell, i) => (
                  <span
                    key={i}
                    className={`${cell.hero ? styles.layoutCardCellHero : styles.layoutCardCell}`}
                    style={cell.style}
                  />
                ))}
              </span>
            </span>
            <span className={styles.layoutCardLabel}>
              {layout.label}
              {layout.count && (
                <span className={styles.layoutCardCount}>{layout.count}</span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default LayoutCard;
